<!--
<div class="container-fluid h-100">
  <app-loader></app-loader>
  <mat-toolbar class="d-flex justify-content-between">
    <div class="d-flex align-items-center">
      <img src="assets/img/logo..svg" alt="Rockefeller Capital Management logo" style="height: 36px;">
      <span class="rcm-accent-gold" style="font-size: 2rem; margin-left: 12px;">|</span>
      <div class="rcm-headline" style="margin-left: 16px; font-size: 1.5rem;">AML PERIODIC CLIENT REVIEW</div>
    </div>
    <div class="d-flex align-items-center">
      <mat-icon style="font-size: 22px !important; color: var(--rcm-flat-gold);" class="pointer m-r-10" inline="true"
        [matMenuTriggerFor]="advTreeMenu" #advMenuTrigger="matMenuTrigger">
        groups
      </mat-icon>
      <span style="color: var(--rcm-flat-gold); font-family: 'Inter', system-ui, sans-serif; font-weight: 600; margin-right: 16px;">{{ loggedInUser?.name }}</span>
      <mat-icon style="font-size: 18px !important; color: var(--rcm-flat-gold);" class="pointer" [matMenuTriggerFor]="superMenu"
        inline="true">more_vert</mat-icon>
    </div>  </mat-toolbar>
</div> -->




  <!-- Advsor Tree - menu-->
  <!-- <mat-menu #advTreeMenu="matMenu" class="advTree-menu">
    <ng-template matMenuContent>
      <div class="flex-col-container m-10" (click)="$event.stopPropagation()">
        <app-advisors-tree-filter *ngIf="advTree?.length" [AdvisorsTreeData]="advTree" [SelectedRepIds]="repIds"
          (OnAppliedFilter)="advListChanged($event)" (cancelFilter)="closeAdvTree()">
        </app-advisors-tree-filter>
      </div>
    </ng-template>
  </mat-menu>
-->
<!-- <button mat-icon-button (click)="sidenav.toggle()">
  <mat-icon style="color: #005CB8;">filter_list</mat-icon>
</button> -->




 <!-- <mat-menu class="pe-3 ps-3" #superMenu="matMenu">
    <div class="" (click)="$event.stopPropagation()">
      <mat-radio-group [(ngModel)]="tempRole" class="" (click)="$event.stopPropagation()">
        <mat-radio-button value="SUPER" (click)="$event.stopPropagation()">SUPER</mat-radio-button>
        <mat-radio-button value="AML" (click)="$event.stopPropagation()">AML</mat-radio-button>
        <mat-radio-button value="BM" (click)="$event.stopPropagation()">DS</mat-radio-button>
        <mat-radio-button value="FA" (click)="$event.stopPropagation()">PA/CA</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="d-flex pt-2 justify-content-start align-bottom">
      <a mat-button color="Primary" class="me-1">Cancel</a>
      <a mat-stroked-button color="accent" (click)="changeUser()">Apply</a>
    </div>
  </mat-menu> -->

<app-loader></app-loader>
<div >
    <router-outlet  class="w3-animate w3-animate-right"></router-outlet>
</div>



<!-- </div> -->